module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/terms/terms.component.css
// module id = ./src/app/terms/terms.component.css
// module chunks = main